import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../modules/shared.module';
import { ConvertPdfWithAiButtonComponent, ConvertPdfWithAiComponent } from './convert-pdf-with-ai.component';
import { SharedInputModule } from '../../modules/shared-input.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    SharedInputModule
  ],
  declarations: [
    ConvertPdfWithAiButtonComponent,
    ConvertPdfWithAiComponent
  ],
  entryComponents: [
    ConvertPdfWithAiButtonComponent,
    ConvertPdfWithAiComponent
  ],
  exports: [
    ConvertPdfWithAiButtonComponent,
    ConvertPdfWithAiComponent
  ]
})

export class ConvertPdfWithAiModule { }